<script setup lang="ts">
import type { ElementsCard } from '@autobid/strapi-integration/rest/components'

const { button } = inject('card') as ElementsCard
</script>

<template>
  <div class="card-button mt-2 mt-auto flex w-full justify-end">
    <!-- @vue-expect-error - color is an enum in the strapi, since the button accepts the string -->
    <elements-button v-if="button" v-bind="button">
      {{ button.text }}
    </elements-button>
  </div>
</template>
